import { useState } from 'react';
import { twJoin } from 'tailwind-merge';

export type Tab<T extends string> = {
  id: T;
  label: string;
};

type Props<T extends string> = {
  items: Tab<T>[];
  onChange: (_id: T) => void;
  initialTab?: T;
};

export const Tabs = <T extends string>({ items, onChange, initialTab }: Props<T>) => {
  const [selectedTab, setSelectedTab] = useState(initialTab ?? items[0]?.id);

  const handleChange = (id: T) => {
    onChange(id);
    setSelectedTab(id);
  };

  if (items.length === 0) {
    return null;
  }

  return (
    <div className="text-sm font-medium text-center text-gray-500 border-b border-gray-200 dark:text-gray-400 dark:border-gray-700">
      <ul className="flex flex-wrap -mb-px">
        {items.map(item => (
          <li className="me-2" key={item.id}>
            <button
              type="button"
              onClick={() => handleChange(item.id)}
              className={twJoin(
                'inline-block p-4 border-b-2 rounded-t-lg',
                item.id === selectedTab
                  ? 'text-cta-600 border-cta-600 dark:text-cta-500 dark:border-cta-500'
                  : 'border-transparent hover:text-gray-600 hover:border-gray-300 dark:hover:text-gray-300',
              )}
            >
              {item.label}
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
};
